import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from './_myRoutesHeader.css'
import PageHeader from 'components/util/PageHeader'
import { FormattedMessage } from 'react-intl'

export default function MyRoutesHeader () {
  // Applying a CSS modules class with the react-router activeClassName prop is not working.
  // Manually adding the styles with the activeStyle prop.
  const ACTIVE = {
    boxShadow: 'inset 0 3px 0 0px #2F98D9',
    background: '#FFFFFF',
    color: '#444444',
  }

  return (
    <div>
      <PageHeader>
        <h1>
          <FormattedMessage id='myroutes.mainheader' defaultMessage='My Routes and Courses' />
        </h1>
      </PageHeader>
      <div className={styles.tabsContainer}>
        <NavLink
          exact
          className={styles.tab}
          activeStyle={ACTIVE}
          to='/routes/my_routes'>
          <FormattedMessage id='myroutes.tab.routes' defaultMessage='Routes' />
        </NavLink>

        <NavLink
          className={styles.tab}
          activeStyle={ACTIVE}
          to='/routes/my_routes/bookmarks'>
          <FormattedMessage id='myroutes.tab.bookmarks' defaultMessage='Bookmarked' />
        </NavLink>

        <NavLink
          className={styles.tab}
          activeStyle={ACTIVE}
          to='/routes/my_routes/courses'>
          <FormattedMessage id='myroutes.tab.courses' defaultMessage='Courses' />
        </NavLink>
      </div>
    </div>
  )
}
